// Import Packages
import React, { useRef, useState, useEffect } from "react";
import Xarrow from "react-xarrows";
import MultiCrops from "react-multi-crops";

// Import Pages
import VariableAssign from "./VariableAssign";
import InputModal from "../../DesktopRecorder/FindAndInput/InputModal";

// Import Material UI
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Dialog, DialogTitle } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Close from "@material-ui/icons/Close";

// Import Helpers
import { isFloat } from '../../../../helpers/helper';

// Import Recoil
import { saveAvailable } from "../../../../recoil-store/recoil-state";
import { useSetRecoilState } from "recoil";

/**
 * @Description this page Cropped image assign variable
 * @Param       action - object
 * @Param       previewCanvasRef - cropping canvas reference
 * @Param       setOpenCaptureArea - open capture area function
 * @Param       crop - crop type
 * @Param       completedCrop - crop completed
 * @Param       setCompletedCrop - crop function
 * @Param       upImg - uploading image
 * @Param       imgRef - image reference
 * @Param       setFirstImageLoading - function
 * @Returns     canvas reference
 * @Author      Kerem Karadeniz
 */

const CaptureArea = ({
    setOpenCaptureArea,
    upImg,
    action,
    setImgCoordinate,
    imgCoordinate,
    setOpenVariable,
    variables,
    isGrid,
    isVariableShow = true,
    isFindAndInput = false,
    isGetText = false,
}) => {
    const [index, setIndex] = useState(0);
    const [open, setOpen] = useState({ status: false, isEdit: false });
    const [isMouseOnImage, setIsMouseOnImage] = useState(true);
    const refSource = useRef(null);
    const refDestination = useRef(null);
    const [refresh, setRefresh] = useState(false);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [openInputModal, setOpenInputModal] = useState(false);
    const [isDraw, setIsDraw] = useState(false);

    let control = action.fields.source?.value?.x > 0;

    useEffect(() => {
        setTimeout(() => {
            if (refSource.current) {
                if (
                    isVariableShow === false &&
                    action.fields.completedCrop.value.length === 1 &&
                    action.fields.source?.value?.x > 0
                ) {
                    let sourceDiv = document.getElementById("source-click-div");
                    //draw line and coordinate
                    sourceDiv.style.position = "absolute";
                    sourceDiv.style.left =
                        Number(action.fields.source.value.x) + 16 + "px";
                    sourceDiv.style.top =
                        Number(action.fields.source.value.y) + 48 + "px";
                    sourceDiv.style.background = "red";
                    sourceDiv.style.width = 5 + "px";
                    sourceDiv.style.height = 5 + "px";
                    sourceDiv.style.zIndex = "99999";
                }
                if (
                    isVariableShow === false &&
                    action.fields.destination?.value?.x > 0 &&
                    action.fields.completedCrop.value.length === 1
                ) {
                    let destinationDiv = document.getElementById("destination-click-div");
                    //draw line and coordinate

                    destinationDiv.style.position = "absolute";
                    destinationDiv.style.left =
                        action.fields.destination?.value?.x + "px";
                    destinationDiv.style.top = action.fields.destination?.value?.y + "px";
                    destinationDiv.style.background = "red";
                    destinationDiv.style.width = 5 + "px";
                    destinationDiv.style.height = 5 + "px";
                    destinationDiv.style.zIndex = "99999";
                }
                setRefresh(!refresh);
            }
        }, 500);
    }, []);

    //added  crop
    function changeCoordinate(coordinate, i, coordinates) {
        const popupImg = document.getElementById("popupImg")
        const width = popupImg.offsetWidth
        const height = popupImg.offsetHeight
        if (coordinate.x < 0 || coordinate.y < 0 || (coordinate.x + coordinate.width) > width || (coordinate.y + coordinate.height) > height) return
        if (isVariableShow === false && coordinates.length <= 1 && isGetText === false) {
            setImgCoordinate({ coordinates });
            if (isGrid === 0) action.fields.completedCrop.value = coordinates;
            else action.fields.gridCrop.value = coordinates;
            setIndex(i);
        } else if (isVariableShow === true && isGetText === false) {
            setImgCoordinate({ coordinates });
            if (isGrid === 0) action.fields.completedCrop.value = coordinates;
            else action.fields.gridCrop.value = coordinates;
            setIndex(i);
        } else if (isVariableShow === true && coordinates.length <= 1 && isGetText === true) {
            setImgCoordinate({ coordinates });
            if (isGrid === 0) action.fields.completedCrop.value = coordinates;
            else action.fields.gridCrop.value = coordinates;
            setIndex(i);
        }
        setSaveAvailable(true)
        if (!isDraw) setIsDraw(true)
    }

    // deleting crop
    function deleteCoordinate(coordinate, i, coordinates) {
        setImgCoordinate({ coordinates });
        if (isGrid === 0) action.fields.completedCrop.value = coordinates;
        else action.fields.gridCrop.value = coordinates;
        if (isVariableShow === false) {
            let sourceDiv = document.getElementById("source-click-div");
            let destinationDiv = document.getElementById("destination-click-div");
            action.fields.source = { value: { x: 0, y: 0 } };
            action.fields.destination = { value: { x: 0, y: 0 } };
            sourceDiv.style.top = "0";
            sourceDiv.style.left = "0";
            destinationDiv.style.top = "0";
            destinationDiv.style.left = "0";
            control = false;
        }
        if (isFindAndInput === true) {
            if (action.fields.inputValue) {
                action.fields.inputValue = { value: "" }
            }
        }
        setSaveAvailable(true)
    }

    //key press event
    function handleKeyEvent(event) {
        if (event.key === "Enter") {
            setOpen({ status: true, isEdit: true });
        }
    }

    function handleMouseEnter(event) {
        if (event.target.nodeName === "IMG") {
            setIsMouseOnImage(true)
        }
        else {
            setIsMouseOnImage(false)
        }
    }

    function handleClicked(event) {
        if (!isDraw) return
        if (event.target.id === "destination-click-div" && isFindAndInput === true) {
            setOpenInputModal(true);
        }
        if (isMouseOnImage) {
            if (isVariableShow === true && isGetText === false) {
                setOpen({ status: true, isEdit: false });
            } else {
                if (
                    isVariableShow === false &&
                    action.fields.completedCrop.value.length === 1 &&
                    control === false
                ) {
                    let sourceDiv = document.getElementById("source-click-div");
                    action.fields.source.value = action.fields.completedCrop.value[0];
                    //draw line and coordinate
                    sourceDiv.style.position = "absolute";
                    sourceDiv.style.left =
                        Number(action.fields.completedCrop.value[0].x) + 16 + "px";
                    sourceDiv.style.top =
                        Number(action.fields.completedCrop.value[0].y) + 68 + "px";
                    sourceDiv.style.background = "red";
                    sourceDiv.style.width = 5 + "px";
                    sourceDiv.style.height = 5 + "px";
                    sourceDiv.style.zIndex = "99999";
                    control = true;
                }
            }
            setIsDraw(false)
        }
    }

    function handleDraw(event) {
        if (event.target.nodeName === "IMG") {
            if (
                isVariableShow === false &&
                control === true &&
                action.fields.source?.value?.x > 0
            ) {
                const popupImg = document.getElementById("popupImg")
                const positionInfoImg = popupImg.getBoundingClientRect();
                const differX = positionInfoImg.x;
                const differY = 60;
                const mainDiv = document.getElementById("capture-area")

                // draw line and coordinate
                let destinationDiv = document.getElementById("destination-click-div");
                destinationDiv.style.position = "absolute";
                destinationDiv.style.left = (event.clientX + mainDiv.scrollLeft) + "px";
                destinationDiv.style.top = (event.clientY + mainDiv.scrollTop) + "px";
                destinationDiv.style.background = "red";
                destinationDiv.style.width = 5 + "px";
                destinationDiv.style.height = 5 + "px";
                destinationDiv.style.zIndex = "99999";
                // Just setting destination value, not related with calculating difference
                action.fields.destination.value.x = event.clientX;
                action.fields.destination.value.y = event.clientY + mainDiv.scrollTop;
                // Calculating difference by using cropped area's position and destination's position, additionally differ with the modal padding values
                let xDifference =
                    action.fields.completedCrop.value[0]?.x - (event.clientX) + differX;
                let yDifference =
                    action.fields.completedCrop.value[0]?.y - (event.clientY + mainDiv.scrollTop) + differY;

                action.fields.difference.value = {
                    x: Math.round(xDifference),
                    y: Math.round(yDifference),
                };
                if (
                    isVariableShow === false &&
                    isFindAndInput === true &&
                    action.fields.source?.value?.x > 0
                ) {
                    setOpenInputModal(true);
                }
                setRefresh(!refresh);
                control = true;
            }
        }
    }

    function handleDoubleClick(event) {
        if (event.target.nodeName === "DIV") {
            if (Number(event.target.innerText)) {
                setIndex(Number(event.target.innerText) - 1);
                setOpen({ status: true, isEdit: true });
            }
        }
    }

    return (
        <div>
            <Dialog
                id="autom-addNew-modal"
                data-test="autom-add-new"
                open={true}
                onKeyDown={(e) => handleKeyEvent(e)}
                fullScreen={true}
                PaperProps={{
                    style: {
                        minWidth: "100%",
                        display: "inline-block",
                    },
                    id: "capture-area"
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    <Button
                        style={{ float: "right" }}
                        data-test="cancelautom-button"
                        onClick={() => setOpenCaptureArea(false)}
                    >
                        <Close />
                    </Button>
                </DialogTitle>
                <DialogContent style={{ display: "inline-block", padding: "8px 0" }}>
                    <div style={{ textAlign: "center", display: "inline-block" }}>
                        <div
                            onClick={(e) => handleClicked(e)}
                            onDoubleClick={(e) => handleDoubleClick(e)}
                            onMouseDown={(e) => handleDraw(e)}
                            onMouseDownCapture={(e) => handleMouseEnter(e)}
                            id="popupImg"
                        >
                            <MultiCrops
                                src={upImg}
                                coordinates={imgCoordinate.coordinates}
                                onChange={changeCoordinate}
                                onDelete={deleteCoordinate}
                            />
                            <div id="source-click-div" ref={refSource} />
                            <div id="destination-click-div" ref={refDestination} />
                            {isVariableShow === false ? (
                                <Xarrow
                                    start={refSource} //can be react ref
                                    end={refDestination} //or an id
                                />
                            ) : null}
                        </div>
                    </div>
                </DialogContent>
                <DialogActions
                    style={{
                        justifyContent: "space-between",
                        padding: "8px 24px 16px 24px",
                    }}
                />
                {open.status && isGrid === 0 && isVariableShow === true && (
                    <VariableAssign
                        index={index}
                        imgCoordinate={imgCoordinate}
                        setImgCoordinate={setImgCoordinate}
                        action={action}
                        upImg={upImg}
                        setOpenCaptureArea={setOpen}
                        setOpenVariable={setOpenVariable}
                        variables={variables}
                        deleteCoordinate={deleteCoordinate}
                        isEdit={open.isEdit}
                    />
                )}
            </Dialog>
            {openInputModal && (
                <InputModal
                    setOpen={setOpenInputModal}
                    action={action}
                    setOpenVariable={setOpenVariable}
                    variables={variables}
                />
            )}
        </div>
    );
};

export default CaptureArea;
